<div class="custom-detail">
    <p class="ms-2 my-2">
        <span class="custom-name">{{crewDetail?.fullName}}</span>
        <span [ngStyle]="{'color':crewDetail?.colorCode}" class="jobtitle-color d-block font-wight-job">{{crewDetail?.jobTitle}}-{{crewDetail?.positionCode}}</span>
    </p>
    <p class="ms-2" *ngIf="crewDetail?.workPhone">
        <img [src]="constants.staticImages.phoneLogo" alt="phone">
        <span class="ms-2">{{crewDetail?.workPhone}}</span>
    </p>
    <p class="ms-2" *ngIf="crewDetail?.email">
        <img [src]="constants.staticImages.emailImage" alt="phone">
        <span class="ms-2">{{crewDetail?.email}}</span>
    </p>
</div>

<div class="mt-2 border-bottom border-secondary pb-3 border-color">
    <p>Other Jobs</p>
    <div class="container-other-job my-2" *ngFor="let otherJob of otherJobDetailsCrew">
        <div class="d-flex flex-column justify-content-between my-2">
            <span class="ms-3 d-block">
        <strong class="d-inline-block"> {{otherJob?.contractId}}
          <span class="ms-2"> {{otherJob?.description}}</span></strong>
            </span>
            <span class="ms-3 d-block">
        <span class="card-text">Hours</span>
            <span class="ms-2 card-text">: {{otherJob?.loggedHours }}</span>
            </span>
        </div>
    </div>
</div>

<div class="row mt-5 border-bottom border-secondary pb-3 border-color">
    <form class="form" [formGroup]="perDiemForm" (ngSubmit)="saveChanges()">
        <div class="form-group mt-2">
            <label for="Per Diem" class="d-block">Per Diem</label>
            <div class="d-flex flex-row flex-nowrap justify-content-between mt-2">
                <img class="mx-3" [src]="constants.staticImages.dollarIcon" alt="dollar ico">
                <input type="number" class="form-control" placeholder="Enter value" name="PerDiemAmount" formControlName="PerDiemAmount">
            </div>
            <div class="mt-1 mx-5">
                <app-error-messages [control]="perDiemForm.controls?.PerDiemAmount"></app-error-messages>
            </div>
        </div>
        <div class="form-group ">
            <label for="exampleFormControlTextarea1 ">Notes</label>
            <textarea class="form-control mt-2 height-text-area" id="exampleFormControlTextarea1" rows="6" name="PerDiemRemarks" formControlName="PerDiemRemarks"></textarea>
        </div>
        <button class="btn btn-primary float-end" type="submit ">Save</button>
    </form>
</div>

<div class="row mt-5" *ngIf="crewPerDiemNotesAmountDetails.length">
    <div class="col-lg-12">
        <p-table [value]="products" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Date</th>
                    <th class="text-center">Per Diem Amount($)</th>
                    <th>Notes</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr *ngFor="let notes of crewPerDiemNotesAmountDetails ">
                    <td [title]="notes?.createdOn | date">{{notes?.createdOn | date :'M/d' }}</td>
                    <td class="text-center">{{notes?.perDiemAmount}}</td>
                    <td>{{notes?.perDiemNotes}}</td>
                    <td>
                        <img class="trash-icon" [src]="constants.staticImages.TrashIcon" alt="Delete Icon" (click)="deletedPerDiemPopup(deletedPerDiem,notes.jobScheduleCrewPerDiemID)">
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<ng-template #deletedPerDiem>
    <app-modal title="Remove PerDiem" [modalRef]="modalRef" [positiveResponse]="'Yes'" (onAction)="deletedPerDiemApi($event)">
        <p class="modal-body">Are you sure you want to remove?</p>
    </app-modal>
</ng-template>
